import winston from 'winston';
import { isSensitiveKey, maskFormat, maskString } from './secrets-sanitizer';
const oneLine = (s) => s.replace(/\r?\n/g, '\\n');
function inspectVal(val, depth, maxDepth, maxArr, maxStr, seen) {
    if (val === null)
        return 'null';
    if (val === undefined)
        return 'undefined';
    if (typeof val === 'string') {
        const s = val.length > maxStr ? `${val.slice(0, maxStr)}...` : val;
        return `'${s}'`;
    }
    if (typeof val === 'number' || typeof val === 'boolean' || typeof val === 'bigint')
        return String(val);
    if (typeof val === 'symbol')
        return val.toString();
    if (typeof val === 'function')
        return `[Function: ${val.name || 'anonymous'}]`;
    if (depth >= maxDepth)
        return Array.isArray(val) ? '[Array]' : '[Object]';
    if (seen.has(val))
        return '[Circular]';
    seen.add(val);
    const next = (v) => inspectVal(v, depth + 1, maxDepth, maxArr, maxStr, new Set(seen));
    if (Array.isArray(val)) {
        const items = val.slice(0, maxArr).map(next);
        const suffix = val.length > maxArr ? `, ... ${val.length - maxArr} more items` : '';
        return `[ ${items.join(', ')}${suffix} ]`;
    }
    if (val instanceof Error)
        return `${val.name}: ${val.message}`;
    const entries = Object.entries(val).map(([k, v]) => `${k}: ${next(v)}`);
    return `{ ${entries.join(', ')} }`;
}
const inspectMeta = (obj) => inspectVal(obj, 0, 6, 50, 500, new Set());
const base = winston.format.combine(winston.format.errors({ stack: true }), winston.format.splat(), winston.format.timestamp({ format: 'YYYY-MM-DD HH:mm:ss' }), winston.format.metadata({
    fillExcept: ['timestamp', 'level', 'message', 'stack']
}), maskFormat());
export const devFormat = winston.format.combine(base, winston.format.colorize({ all: true }), winston.format.printf((info) => {
    const ts = String(info.timestamp ?? '');
    const level = String(info.level ?? '');
    const rawMsg = typeof info.message === 'string' ? info.message : inspectMeta(info.message);
    let line = `[${ts}] [${level}] ${rawMsg}`;
    if (info.metadata && Object.keys(info.metadata).length > 0) {
        line += ` ${oneLine(inspectMeta(info.metadata))}`;
    }
    if (info.stack) {
        line += ` stack=${oneLine(String(info.stack))}`;
    }
    return line;
}));
export const prodFormat = winston.format.combine(base, winston.format.json({
    replacer: (k, v) => {
        if (isSensitiveKey(k))
            return '[REDACTED]';
        if (typeof v === 'string')
            return oneLine(maskString(v));
        return v;
    },
    space: 0
}));
export const logger = winston.createLogger({
    exitOnError: false,
    level: String(process.env.LOG_LEVEL || 'info'),
    format: process.env.ENV === 'local' ? devFormat : prodFormat,
    transports: [new winston.transports.Console()]
});
export default logger;
